var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-dialog", {
    attrs: {
      title: "编辑昵称",
      visible: _vm.dialogVisible,
      width: "30%",
      "append-to-body": "",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    ref: "form",
    attrs: {
      "status-icon": "",
      model: _vm.form,
      rules: _vm.rules,
      "label-width": "80px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "用户昵称",
      prop: "nickName"
    }
  }, [_c("el-input", {
    staticClass: "inputText",
    attrs: {
      disabled: _vm.disabled,
      clearable: "",
      autocomplete: "off"
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.save();
      }
    },
    model: {
      value: _vm.form.nickName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "nickName", $$v);
      },
      expression: "form.nickName"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "用户头像",
      prop: "headUrl"
    }
  }, [_c("el-upload", {
    attrs: {
      headers: _vm.uploadHeaders,
      action: _vm.uploadUrl + "admin/v1/file/uploadFileImg",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [_vm.imageUrl ? _c("img", {
    staticClass: "avatar",
    attrs: {
      src: _vm.imageUrl
    }
  }) : _c("i", {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1)], 1), _c("div", {
    staticClass: "bottomDiv"
  }, [_c("el-button", {
    on: {
      click: _vm.handleClose
    }
  }, [_vm._v("关闭")]), _c("el-button", {
    attrs: {
      disabled: _vm.disabled,
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("保存")])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };